import React from 'react';

import { params } from '@aline/routes';
import { useDrawerSearchParam } from 'src/editor/toolbars/right-panel/drawer-search-params';

import { AddInputPanel } from './add-input-panel';
import { InputFieldDetailPanel } from '../inputs';

export function AddInputDrawer(): JSX.Element | null {
  const { value: newFieldId } = useDrawerSearchParam(params.rightPanel.newFieldId);

  if (!newFieldId) return <AddInputPanel />;

  return <InputFieldDetailPanel newFieldId={newFieldId} />;
}
